var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCancelOptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12C1.5 14.0767 2.11581 16.1068 3.26957 17.8335C4.42332 19.5602 6.0632 20.906 7.98182 21.7007C9.90045 22.4955 12.0116 22.7034 14.0484 22.2982C16.0852 21.8931 17.9562 20.8931 19.4246 19.4246C20.8931 17.9562 21.8931 16.0852 22.2982 14.0484C22.7034 12.0116 22.4955 9.90045 21.7007 7.98182C20.906 6.0632 19.5602 4.42332 17.8335 3.26957C16.1068 2.11581 14.0767 1.5 12 1.5C9.21523 1.5 6.54451 2.60625 4.57538 4.57538C2.60625 6.54451 1.5 9.21523 1.5 12ZM18.8625 17.8125L6.1875 5.1375C7.91298 3.70125 10.1129 2.96173 12.3556 3.0641C14.5983 3.16646 16.7218 4.10331 18.3092 5.69077C19.8967 7.27824 20.8335 9.40169 20.9359 11.6444C21.0383 13.8871 20.2988 16.087 18.8625 17.8125ZM6.18 18.87C4.36374 17.3276 3.23325 15.1279 3.03642 12.7533C2.83959 10.3787 3.59248 8.02286 5.13 6.2025L17.7975 18.87C16.1732 20.2425 14.1153 20.9955 11.9887 20.9955C9.86219 20.9955 7.80433 20.2425 6.18 18.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancelOptions);
export default __webpack_public_path__ + "static/media/ic-cancel-options.7ff406b2df734f42ab98252940de606c.svg";
export { ForwardRef as ReactComponent };